// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bruteforcesettings-" + chunkId + ".js?v=" + {"node_modules_nextcloud_dialogs_dist_chunks_index-Cp_Wd5Qd_mjs":"873722305021364c3e88","vendors-node_modules_rehype-highlight_index_js":"a0d1c632413cd555c833","vendors-node_modules_nextcloud_dialogs_dist_chunks_FilePicker-Bp973DaS_mjs":"29bc07350ded0cabefe9"}[chunkId] + "";
};